import React, { FC } from "react";
import { CardContent as MuiCardContent, CardContentProps } from "@mui/material";

const CardContent: FC<CardContentProps> = (props) => <MuiCardContent {...props} />;

export default CardContent;
